// extracted by mini-css-extract-plugin
module.exports = {"Page":"Page_Page__1wnwF","Content":"Page_Content__qFJW_"};